/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'f1z8hWRLkN284wYEPUPDoX.png': { uri: '/images/f1z8hWRLkN284wYEPUPDoX.png' },
'tB2BXPvfm2orAyNYuW7w7T.png': { uri: '/images/tB2BXPvfm2orAyNYuW7w7T.png' },
'uiqRq3F4dFSPxrRGbgpZJR.png': { uri: '/images/uiqRq3F4dFSPxrRGbgpZJR.png' },
'pQPQoZo4Hwg7rkLFCSqTjN.png': { uri: '/images/pQPQoZo4Hwg7rkLFCSqTjN.png' },
'jRc3mxfXew5Ased6daNgHr.png': { uri: '/images/jRc3mxfXew5Ased6daNgHr.png' },
'2svL883LFbBpiZ1EzQe7Nw.png': { uri: '/images/2svL883LFbBpiZ1EzQe7Nw.png' },
'whiZAqM9SoSPTrh2Yxr97y.png': { uri: '/images/whiZAqM9SoSPTrh2Yxr97y.png' },
'bi2ubAeudVuoSv1xeGEhjv.png': { uri: '/images/bi2ubAeudVuoSv1xeGEhjv.png' },
'1ydjsyCPqBnhzVfarEJMpR.png': { uri: '/images/1ydjsyCPqBnhzVfarEJMpR.png' },
'831is4wQvgNQrkUknnxfqT.png': { uri: '/images/831is4wQvgNQrkUknnxfqT.png' },
'gr4i87oy7S26pxWhE3fV7e.png': { uri: '/images/gr4i87oy7S26pxWhE3fV7e.png' },
'smVr3RpqF3i9TjWwvJL6fG.png': { uri: '/images/smVr3RpqF3i9TjWwvJL6fG.png' },
'8LLFQGmT8rba7WtSpX83Q2.png': { uri: '/images/8LLFQGmT8rba7WtSpX83Q2.png' },
'tP3UdSAb2K5iBkCmEFcLPs.png': { uri: '/images/tP3UdSAb2K5iBkCmEFcLPs.png' },
'bxiDTzySLGH99SzhFyeHbr.png': { uri: '/images/bxiDTzySLGH99SzhFyeHbr.png' },
'14wE8TNfcjmrzsMktjZ4cS.png': { uri: '/images/14wE8TNfcjmrzsMktjZ4cS.png' },
'eqz65riTwukRmDUfLyd9sn.png': { uri: '/images/eqz65riTwukRmDUfLyd9sn.png' },
'uzJMo3df62KDL6UYbyXfNT.png': { uri: '/images/uzJMo3df62KDL6UYbyXfNT.png' },
'cGunQtF4NWquPexPfjR9HA.png': { uri: '/images/cGunQtF4NWquPexPfjR9HA.png' },
'cv2RYyXrpEw6LDk6RSRTVB.png': { uri: '/images/cv2RYyXrpEw6LDk6RSRTVB.png' },
'gkvtMFaRTRXtqeK3FDmZnR.png': { uri: '/images/gkvtMFaRTRXtqeK3FDmZnR.png' },
'rpt69QshJ5ppSUNS57Zvd3.png': { uri: '/images/rpt69QshJ5ppSUNS57Zvd3.png' },
'88TfuiqZV4MjPa52BTFGYi.png': { uri: '/images/88TfuiqZV4MjPa52BTFGYi.png' },
'8rdH4md1g7g9LvjYmNWxg4.png': { uri: '/images/8rdH4md1g7g9LvjYmNWxg4.png' },
'mPWHJp6YraQSAHMqWUcWcU.png': { uri: '/images/mPWHJp6YraQSAHMqWUcWcU.png' },
'vntTnnqfCWvidpxhUDputm.png': { uri: '/images/vntTnnqfCWvidpxhUDputm.png' },
'qZ9nGSemWG4v6pwGowqtex.png': { uri: '/images/qZ9nGSemWG4v6pwGowqtex.png' },
'cEn43gkyYCzopQknSzpM7U.png': { uri: '/images/cEn43gkyYCzopQknSzpM7U.png' },
'pyvjr1ZcisGu9YV1qU2nDn.png': { uri: '/images/pyvjr1ZcisGu9YV1qU2nDn.png' },
'djFoMjfYgUtYt1vUPQ8rdv.png': { uri: '/images/djFoMjfYgUtYt1vUPQ8rdv.png' },
'5WEeUXTHzKDD5tmqcpj6xH.png': { uri: '/images/5WEeUXTHzKDD5tmqcpj6xH.png' },
'fiDEzv1BS2spygYN2JqDjr.png': { uri: '/images/fiDEzv1BS2spygYN2JqDjr.png' }
}

export default imageStaticSourcesByFileName
